import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  SearchPanel,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4';

import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';

import { SearchState } from '@devexpress/dx-react-grid';
import { Loading } from '../../components/Loading/loading';


const APIURL = `${process.env.REACT_APP_API_HOST}standards`;

const SORT_FIELD_MAP = {};

export default function Index() {

  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'STANDARD_ID', title: 'ID' },
    { name: 'STANDARD_NAME', title: 'Name' },
    { name: 'STANDARD_DESC', title: 'Description' },
  ]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'STANDARD_ID', direction: 'asc' }]);

  const commitChanges = async ({ added, changed, deleted }) => {

    try {

      if (added) {
        const newItem = {...added.pop()};
        const response = await axios.post(APIURL, newItem);
        if (response.status !== 201) throw new Error(`Create new error`);
        return fetchData();
      }

      if (changed) {
        const id = Object.keys(changed).pop();
        const response = await axios.put(`${APIURL}/${id}`, changed[id]);
        if (response.status !== 200) throw new Error('Update error');

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `standard successfuly updated`,
            message: ``,
          }
        });

        return fetchData();
      }

      if (deleted) {
        const item = rows.find(row => row.STANDARD_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${APIURL}/${item.STANDARD_ID}`);
          if (response.status !== 204) throw new Error('Update error');
          return fetchData();
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure`,
            message: `You are about to delete "${item.STANDARD_NAME}" standard.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }

  };

  const getRowId = row => row.STANDARD_ID;

  const fetchData = async () => {

    try {

      setLoading(true);

      const orderBy = sorting?.[0];
      const response = await axios.get(`${APIURL}`, {
        params: {
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });
      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      setLoading(false);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(fetchData, [searchValue, pageSize, currentPage, sorting]);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            standard
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Standard List</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <SearchState onValueChange={setSearchValue} />

                    <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />

                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <CustomPaging totalCount={totalCount} />
                    <EditingState
                      onCommitChanges={commitChanges}
                    />
                    <Table />
                    <TableHeaderRow showSortingControls />
                    <TableEditColumn
                      showAddCommand
                      showEditCommand
                      showDeleteCommand
                    />
                    <PagingPanel
                      pageSizes={pageSizes}
                    />
                    <PopupEditing popupComponent={Popup} />
                    <Toolbar />
                    <SearchPanel />
                    {loading && <Loading />}
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}